module.exports = __webpack_public_path__ + "img/logo_scientific.92d4e2cd.png";